export default __webpack_public_path__ + "fonts/vacant-land.svg";